export * from 'bundles/tasks/workflows/editor/store/workflow/actions';

export const REMOVE_ASSIGNEE_GROUP = 'REMOVE_ASSIGNEE_GROUP';
export const REMOVE_ASSIGNEE = 'REMOVE_ASSIGNEE';
export function removeApprover(step, approverGroup, approver) {
  if (approverGroup.assignees.length === 1) {
    return {
      type: REMOVE_ASSIGNEE_GROUP,
      assigneeGroup: approverGroup,
      step
    };
  }

  return {
    type: REMOVE_ASSIGNEE,
    assignee: approver,
    assigneeGroup: approverGroup,
    step
  };
} 